import React from 'react';
import '../styles/main.css';
import Navbar from './Navbar';


function Home() {
return (
        <div className='flex'>
            <a href="/">Home</a>
        </div>
    );
}

export default Home;
